import React from 'react';
import { IonButton, IonCard, IonCardContent, IonCol, IonGrid, IonLabel, IonModal, IonRow } from '@ionic/react';
import { LOAD_UN_ASSIGN_FAIL, LOAD_UN_ASSIGN_SUCCESS, MODULES, UNASSIGN_DRIVER_POPUP_TITLE } from '../../../utils/constants';
import i18n from '../../../../i18n';
import './driverUnAssignment.scss'
import { IONICWrapper } from '../../../utils/common';
import { CarrierLoads } from '../../../models/home/CarrierAssignLoad.model';
import { IAssignShipmentToDriverInputProps } from '../../../schemas/carrierAssign/CarrierAssign.schema';
import { useDispatch, useSelector } from 'react-redux';
import { inTransitData, loadAssignedData, loadCarrierData, unAssignDriverToShipment } from '../../../actions/carrierAssign/action';
import { ToastMessage } from '../../../utils/ToastMessage';
import { getLoadData } from '../../../selectors/Myload/selector';
import { getUserMasterData } from '../../../selectors/selector';
import { LoadStop } from '../loadStops/loadStops';
import { ShipmentDetails } from '../shipment-details/shipmentDetails';
import { useHistory } from 'react-router';
import { Persona } from "../persona/persona";
import { IEShipmentInvolvedParty } from '../../../schemas/getShipment/GetShipment.schema';

export const DriverUnAssignment = (props: any) => {
  const selectedLoad = props.loadDetails || {};
  const shipmentId = selectedLoad.shipmentId;
  const driverName = getDriverName(props.module, selectedLoad);
  const dispatch = useDispatch();
  const loadData = useSelector(getLoadData());
  const userDetails = useSelector(getUserMasterData());
  const history = useHistory();

  const handleAlert = (status: boolean) => {
    if (status) {
      const inTransitLoads = loadData.inTransitLoad;
      let driverDetails: any = [];
      if (selectedLoad.driverAssignmentStatus) {
        driverDetails = selectedLoad.shipmentInvolvedParties && selectedLoad.shipmentInvolvedParties.filter((data: any) => {
          return data.partyType === "PRIMARY DRIVER";
        });
        driverDetails = driverDetails[0];
      } else {
        driverDetails = selectedLoad.assignmentTransaction && selectedLoad.assignmentTransaction[0];
      }
      const dispatcherDetails = IONICWrapper.details.auth.user;
      const obj: CarrierLoads = new CarrierLoads();
      const driverName: any = () => {
        let driver = driverDetails && driverDetails.partyName || driverDetails.driverName;
        return !!driver ? driver : "";
      }
      const driverEmail: any = () => {
        let driverEmail = driverDetails && driverDetails.partyEmail || driverDetails.driverEmail;
        return !!driverEmail ? driverEmail : "";
      }
      const _unAssignDriver: IAssignShipmentToDriverInputProps = {
        carrierId: userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
        dispatcherEmail: dispatcherDetails["signInNames.emailAddress"],
        dispatcherId: dispatcherDetails.upn,
        dispatcherName: `${userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.firstName || ""} ${userDetails && userDetails.memberDetailsResponse &&
            userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.lastName ||
          ""}`,
        dispatcherPhone:userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.mobileNumber,
        driverEmail: driverEmail(),
        driverId: driverDetails && driverDetails.partyId || driverDetails.driverId,
        driverName: driverName(),
        driverPhone: driverDetails && driverDetails.partyPhone || driverDetails.driverPhone,
        shipmentId: shipmentId,
        sourceSystem: selectedLoad && selectedLoad.sourceTMS,
        action: "DRIVER_UNASSIGNMENT_REQUEST",
        tractorNumber: "",
        upn:userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn
      };
      dispatch(unAssignDriverToShipment(obj.unAssignShipmentToDriver(_unAssignDriver), async (response: any) => {
        if (!response.unassignDriverFromShipment && response.errors && response.errors.length) {
          await ToastMessage.show(LOAD_UN_ASSIGN_FAIL);
        } else if (!response.unassignDriverFromShipment.status && response.unassignDriverFromShipment.message.length) {
          await ToastMessage.show(response.unassignDriverFromShipment.message);
        }
        else {
          if (props.module === MODULES.INTRANSIT_MODULE) {
            const { shipment } = response.unassignDriverFromShipment;
            const updatedShipment = inTransitLoads.map((load: any) => {
              if (load.shipmentId === shipmentId) {
                return shipment;
              }
              return load;
            });
            response.unassignDriverFromShipment && dispatch(inTransitData(updatedShipment, updatedShipment.length));
          }
          if (props.module === MODULES.DRIVER_ASSIGNED_MODULE) {
            let carrierLoads: any[] = [];
            if (loadData && loadData.driverLoad) {
              const driverLoads = loadData.driverLoad.filter(
                (item: any) => item.shipmentId !== shipmentId
              );
              dispatch(loadAssignedData(driverLoads, driverLoads.length));
            }
            if (loadData && loadData.carrierLoad) {
              carrierLoads = loadData.carrierLoad.concat({ ...selectedLoad });
              dispatch(loadCarrierData(carrierLoads, carrierLoads.length));
            }
            history.push("/app/"+props.module, {
              shipments: [],
              module: props.module,
              shipmentId: null,
              callExistingAPI: false
            });
          }
          await ToastMessage.show(LOAD_UN_ASSIGN_SUCCESS.replace("#{{LOAD_ID}}", shipmentId).replace("{{DRIVER_NAME}}", driverDetails.partyName || driverDetails.driverName));
        }
      }));
    }
    props.handleAlert();
  }

  let loadStops: any[] = (selectedLoad && selectedLoad.loadStop) || [];
  loadStops =
    loadStops.slice().sort((load1: any, load2: any) => {
      if (load1.sequenceNo && load2.sequenceNo) {
        return load1.sequenceNo - load2.sequenceNo;
      }
      if (load1.stopSequence && load2.stopSequence) {
        return load1.stopSequence - load2.stopSequence;
      }
      return 0;
    }) || [];

  const loadStopsToShow: any[] = [];

  loadStops.forEach((load: any, index: number) => {
    if (index == 0 || index == loadStops.length - 1) {
      loadStopsToShow.push(load);
    }
  });

  return (
    <>
      <IonModal
        isOpen={props.showAlert}
        cssClass={`unAssignModal-web ${props.module === MODULES.DRIVER_ASSIGNED_MODULE ? '' : "intransitModal"}`}
        backdropDismiss={false}
        mode="md"
      >
        <header>
          <IonLabel color="dark">
            {UNASSIGN_DRIVER_POPUP_TITLE.replace(
              "#Driver",
              driverName
            ).replace(
              "LoadId",
              shipmentId
            )}
          </IonLabel>
        </header>
        <section>
          <IonCard className="ion-card-updated">
            <IonCardContent className="card-content">
              <IonGrid class="load-grid">
                <IonRow className="ion-card-row">
                  <IonCol className="card-price-col" size="4">
                    <ShipmentDetails
                      {...selectedLoad}
                      loadId={shipmentId}
                      isCarrierLoad={true}
                      showLoadNo={false}
                    />
                  </IonCol>
                  <IonCol className="card-city-col">
                    <LoadStop
                      loadStops={loadStopsToShow}
                    />
                  </IonCol>
                  <IonCol size="3" className="cnf-driver-persona-col">
                    <Persona
                      showName={true}
                      name={driverName}
                    />
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonCardContent>
          </IonCard>
        </section>
        <footer>
          <IonCol>
            <IonButton
              data-test="ion-button-cancel"
              class="secondary-cta-btn-web"
              onClick={() => handleAlert(false)}
            >
              {i18n.t("NO")}
            </IonButton>
          </IonCol>
          <IonCol>
            <IonButton
              data-test="ion-button-confrim"
              class="primary-cta-btn-web"
              onClick={() => handleAlert(true)}
            >
              {i18n.t("YES")}
            </IonButton>
          </IonCol>
          {props.module === MODULES.DRIVER_ASSIGNED_MODULE ?
            <p className="footer_p">
              load will return to <span>Carrier Assigned </span>for later assignment
	        </p> : null
          }
          <p className="footer_p">
            if you need to be removed from this load, <span className="underline">Contact Schneider</span>
          </p>
        </footer>
      </IonModal>
    </>
  )
}

const getDriverName = (module: string, loadDetails: any) => {
  let driverName: any = "";
  if (
    module !== MODULES.DRIVER_ASSIGNED_MODULE ||
    (module === MODULES.DRIVER_ASSIGNED_MODULE &&
      loadDetails.driverAssignmentStatus === true)
  ) {
    driverName =
      loadDetails.shipmentInvolvedParties &&
      loadDetails.shipmentInvolvedParties.filter((data: IEShipmentInvolvedParty) => {
        return data.partyType === "PRIMARY DRIVER";
      });
    driverName =
      driverName && driverName.length ? driverName[0].partyName : "";
  }

  if (
    loadDetails.driverAssignmentStatus === false &&
    module === MODULES.DRIVER_ASSIGNED_MODULE
  ) {
    driverName =
      loadDetails.assignmentTransaction &&
      loadDetails.assignmentTransaction[0] &&
      loadDetails.assignmentTransaction[0].driverName;
  }
  return driverName;
}
